import { ATTR_FORM, ATTR_SECTION } from '/bb/constants.js';
import { resolveField } from '/bb/identifier.js';
import { getState } from '/bb/state.js';
import { RS_SESSION_COOKIE_NAME, getCookie } from '/utils.js';
import { BB_WARNING } from './config.js';
import { BB_COLLECT_STATUS, getBbIntegrationState } from './integration-state.js';

export function getBbDebugState({ getAppId }) {
  const integration = getBbIntegrationState();
  const counts = countDom();
  const warnings = integration.warnings.slice();

  if (counts.forms === 0) addUnique(warnings, BB_WARNING.NO_FORMS_DETECTED);
  if (counts.sections === 0) addUnique(warnings, BB_WARNING.NO_SECTIONS_DETECTED);
  if (!storageAvailable()) addUnique(warnings, BB_WARNING.STORAGE_UNAVAILABLE);
  if (integration.lastCollectStatus === BB_COLLECT_STATUS.ERROR) {
    addUnique(warnings, BB_WARNING.LAST_COLLECT_FAILED);
  }
  if (integration.lastCollectStatus === BB_COLLECT_STATUS.TIMEOUT) {
    addUnique(warnings, BB_WARNING.LAST_COLLECT_TIMEOUT);
  }

  return {
    configured: !!getAppId(),
    enabled: integration.enabled,
    auto: integration.auto,
    mode: integration.mode,
    lifecycle: getState().lifecycle,
    session_id: readSessionId(),
    forms_detected: counts.forms,
    fields_detected: counts.fields,
    sections_detected: counts.sections,
    last_collect_status: integration.lastCollectStatus,
    last_save_status: integration.lastCollectStatus,
    warnings,
  };
}

function countDom() {
  if (typeof document === 'undefined') return { forms: 0, fields: 0, sections: 0 };

  const forms = new Set();
  const formElements = document.querySelectorAll('form');
  for (let i = 0; i < formElements.length; i++) {
    forms.add(formElements[i]);
  }

  const markedForms = document.querySelectorAll(`[${ATTR_FORM}]`);
  for (let i = 0; i < markedForms.length; i++) {
    forms.add(markedForms[i]);
  }

  let fields = 0;
  const fieldElements = document.querySelectorAll('input,textarea,select');
  for (let i = 0; i < fieldElements.length; i++) {
    const field = fieldElements[i];
    if (resolveField(field)) fields += 1;
  }

  return {
    forms: forms.size,
    fields,
    sections: document.querySelectorAll(`[${ATTR_SECTION}]`).length,
  };
}

function readSessionId() {
  if (typeof document === 'undefined') return null;
  return getCookie(RS_SESSION_COOKIE_NAME);
}

function storageAvailable() {
  try {
    return typeof sessionStorage !== 'undefined' && typeof localStorage !== 'undefined';
  } catch (e) {
    return false;
  }
}

function addUnique(list, value) {
  if (!list.includes(value)) list.push(value);
}
